/**
 * Runtime-safe application build label.
 *
 * Never references the bare compile-time identifier `__JPH_BUILD__`.
 * Readdy and other hosts may not inject Vite `define` globals.
 */

export function getAppBuildLabel(): string {
  const candidates = [
    import.meta.env.VITE_APP_BUILD,
    import.meta.env.VITE_VERCEL_GIT_COMMIT_SHA,
    import.meta.env.VITE_GIT_COMMIT_SHA,
    import.meta.env.VITE_READDY_VERSION_ID,
  ];

  const value = candidates.find(
    (candidate): candidate is string =>
      typeof candidate === 'string' && candidate.trim().length > 0
  );

  if (value) return value.trim().slice(0, 12);

  return typeof import.meta.env.MODE === 'string' ? import.meta.env.MODE : 'unknown';
}

export const JPH_APP_BUILD_LABEL = getAppBuildLabel();
